






































import { mapGetters } from 'vuex'
import { formatWithThousands } from 'plankton'
import TableRow from '@/components/TableRow.vue'
import TableCell from '@/components/TableCell.vue'
import OrderIdTableCell from '@/components/OrderIdTableCell.vue'
import OrderRouteTableCells from '@/components/OrderRouteTableCells.vue'
import OrderRequirementsTableCell from '@/components/OrderRequirementsTableCell.vue'
import OrderLoadDescriptionTableCell from '@/components/OrderLoadDescriptionTableCell.vue'
import OrderSpecificationsTableCell from '@/components/OrderSpecificationsTableCell.vue'
import ContactTableCell from '@/components/ContactTableCell.vue'
import { OrderAssignmentState } from '@/services/models/order-assignments-model'

export default {
  components: {
    TableRow,
    TableCell,
    OrderIdTableCell,
    OrderRouteTableCells,
    OrderRequirementsTableCell,
    OrderLoadDescriptionTableCell,
    OrderSpecificationsTableCell,
    ContactTableCell
  },
  props: {
    orderAssignment: { type: Object, required: true },
    order: { type: Object, required: true },
    multiStop: { type: Object, required: true }
  },
  computed: {
    ...mapGetters(['contactInfo']),
    isCanceled(): boolean {
      return this.orderAssignment.state === OrderAssignmentState.Cancelled
    },
    isRejected(): boolean {
      return this.orderAssignment.state === OrderAssignmentState.Rejected
    },
    revenue(): string {
      const { price } = this.orderAssignment
      return price ? `€ ${formatWithThousands(price)}` : '-'
    },
    validityLabel(): string {
      if (this.isCanceled)
        return this.$t('myAssignments.assignmentRow.validation.cancelled')
      if (this.isRejected)
        return this.$t('myAssignments.assignmentRow.validation.rejected')
      return this.$t('myAssignments.assignmentRow.validation.expired')
    }
  }
}
